import { render, staticRenderFns } from "./DataTableDemo.vue?vue&type=template&id=65d8cf9a&"
import script from "./DataTableDemo.vue?vue&type=script&lang=js&"
export * from "./DataTableDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports